import React, { useEffect, useState } from "react";
import "./App.css"; // Import your custom CSS
//react-router
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
//utils and helpers
import { isAuthenticated } from "./utils/auth";
//modals
import LoadingModal from "./components/utils/LoadingModal";
import DashboardFranchise from "./components/Franchise/Dashboard";
import DashboardCommercial from "./components/Commercial/DashboardCommercial";
import DashboardAdminV from "./components/Admin_V/DashboardAdminV";
import LoginForm from "./components/LoginForm";

//pages
import StockPage from "./components/Admin_V/StockPage";
import BatchDetails from "./components/Admin_V/BatchDetails";
import { FranchisePageCommercial } from "./components/Commercial/FranchisePageCommercial";
import { FranchisePageAdminV } from "./components/Admin_V/FranchisePageAdminV";
import { CommercialPageAdminV } from "./components/Admin_V/CommercialPageAdminV";
import {CreateUserPage} from "./components/Admin_V/CreateUserPage"
//layoutes
import AdminLayout from "./components/Admin_V/AdminLaout";
import CommercialLayout from "./components/Commercial/CommercialLayout";
import FranchiseLayout from "./components/Franchise/FranchiseLayout";
import CommercialPage from "./components/Admin_V/CommercialPage";
import FranchisePage from "./components/Admin_V/FranchisePage";
import FranchisesPage from "./components/Commercial/FranchisesPage";
import PDVPage from "./components/Franchise/PDVPage";
import PDVDetailsPage from "./components/Franchise/PDVDetailsPage";
import UsersPage from "./components/Admin_V/UsersPage";
import SimsPage from "./components/Common/SimsPage";
import TransactionsPage from "./components/Common/TransactionsPage";
import NotificationsPage from "./components/Common/NotificationsPage";
import UserSettings from "./components/Common/UserSettings"
const App = () => {
  const [isAuth, setIsAuth] = useState(null);
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

 
  useEffect(() => {
    setError(""); // Clear any previous errors
    setLoading(true);
    const checkAuth = async () => {
      try {
        const authreq = await isAuthenticated();
        setIsAuth(authreq.isAuth);
        setRole(authreq.role);
      } catch (error) {
        setError("Authentication check failed");
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
    setLoading(false);
  }, []);
  useEffect(() => {}, [isAuth]);
  return (
    <div>
      {loading && <LoadingModal />}
      <Router>
        {isAuth === null ? (
          // Show loading while authentication check is in progress
          <LoadingModal />
        ) : isAuth === false ? (
          // Redirect to login if not authenticated

          <Route path="*" element={<LoginForm />} />
        ) : (
          // Show routes based on role if authenticated
          <Routes>
            {role === "ADMIN" && (
              <Route path="/" element={<AdminLayout />}>
                <Route index element={<DashboardAdminV />} />
                <Route
                  path="commercial/:id"
                  element={<CommercialPageAdminV />}
                />
                <Route path="franchise/:id" element={<FranchisePageAdminV />} />
                <Route path="alerts" element={<NotificationsPage />} />
                <Route path="settings" element={<UserSettings />} />
                <Route path="stock" element={<StockPage />} />
                <Route path="commerciaux" element={<CommercialPage />} />
                <Route path="batch/:id" element={<BatchDetails />} />
                <Route path="franchises" element={<FranchisePage />} />
                <Route path="Utilisateurs" element={<UsersPage />} />
                <Route path="simsPage" element={<SimsPage/>} />
                <Route path="transactionsPage" element={<TransactionsPage/>} />
                <Route path="createUser" element={<CreateUserPage/>} />
              </Route>
            )}
            {role === "COMMERCIAL" && (
              <Route path="/" element={<CommercialLayout />}>
                <Route index element={<DashboardCommercial />} />
                <Route
                  path="franchise/:id"
                  element={<FranchisePageCommercial />}
                />
                <Route path="alerts/" element={<NotificationsPage />} />
                <Route path="settings/" element={<UserSettings />} />
                <Route path="franchises/" element={<FranchisesPage />} />
                <Route path="simsPage" element={<SimsPage/>} />
                <Route path="transactionsPage" element={<TransactionsPage/>} />
              </Route>
            )}
            {role === "FRANCHISE" && (
              <Route path="/" element={<FranchiseLayout />}>
                <Route index element={<DashboardFranchise />} />
                <Route path="pdv" element={<PDVPage />} />
                <Route path="/pdvPage" element={<PDVDetailsPage/>} />
                <Route path="alerts/" element={<NotificationsPage />} />
                <Route path="settings/" element={<UserSettings />} />
                <Route path="simsPage" element={<SimsPage/>} />
                <Route path="transactionsPage" element={<TransactionsPage/>} />
              </Route>
            )}
            <Route path="*" element={<LoginForm />} />
          </Routes>
        )}
      </Router>
    </div>
  );
};

export default App;
